import { messengerRepo } from './messenger.repo'
import type { CallRecord, Conversation, Message } from '../types'

/**
 * Service facade for the messenger feature.
 *
 * Components and stores should call methods here rather than reaching into
 * the repo or `mock-data.ts` directly. When the real backend lands, swap
 * the repo implementation — this service signature stays stable.
 */
export const messengerService = {
  async listConversations(): Promise<Conversation[]> {
    return messengerRepo.listConversations()
  },
  async listCalls(): Promise<CallRecord[]> {
    return messengerRepo.listCalls()
  },
  async getMessages(conversationId: string): Promise<Message[]> {
    if (!conversationId) throw new Error('Conversation id is required')
    return messengerRepo.getMessages(conversationId)
  },
}
